import { toast } from '@codes/ui-kit/components/ui/use-toast';

import { fetchOwner, useOwnerStore } from '@codes/owner';

export const useOwner = () => {
    const setOwner = useOwnerStore(state => state.setOwner);

    const fetchAndSetOwner = async () => {
        try {
            const owner = await fetchOwner();
            setOwner(owner);

            return owner;
        } catch (error) {
            console.error('Failed to fetch Owner:', error);
            toast({
                title: 'Failed to fetch Owner',
                duration: 2000,
            });
        }
    };

    return { fetchAndSetOwner };
};
